import { getToken, setToken, removeToken } from '@/utils/auth';
import Route from '@/router';
import api from '@/api/modules/index';

const user = {
  state: {
    user: '',
    name: '',
    status: '',
    token: getToken(),
    avatar: 'static/avatar.gif',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    }
  },

  getters: {
    name: state => state.user.name,
    avatar: state => state.user.avatar,
    roles: state => state.user.roles,
    token: state => state.user.token
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting;
    },
    SET_STATUS: (state, status) => {
      state.status = status;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_avatar: (state, avatar) => {
      state.avatar = avatar ? avatar : 'static/avatar.gif';
    }
  },

  actions: {
    // 后端登出
    LogOut({ commit, state }) {
      api.user_logout().then(res => {
        console.log(res);
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        removeToken();
        localStorage.removeItem('ipp_token');
        Route.push('/login');
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      commit('SET_TOKEN', '');
      removeToken();
      Route.push('/login');
    }
  }
};

export default user;
